/* eslint-disable react-hooks/exhaustive-deps */
import { useState, useEffect, useContext } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { getlocalStorage } from "../../utils/getlocalStorage";
import { rarityInstance, withoutAuth } from "../../config/axios";
import Button from "react-bootstrap/Button";
import { CopyToClipboard } from "react-copy-to-clipboard";

import Loader from "../loader/loader";
import DiaryLayout from "../layout/diaryLayout";
import DiaryGIA from "./diaryGIA";
import DiarySaturation from "./diarySaturation";
import DiaryOrigin from "./diaryOrigin";
import DiaryShape from "./diaryShape";
import LuxuryHistory from "./luxuryHistory";
import DiaryFluorescence from "./diaryFluorescence";
import DiaryClarity from "./diaryClarity";
import DiaryWeight from "./diaryWeight";
import DiaryWeightPDF from "./diaryWeightPDF";
import DiaryDiamondIndex from "./diaryDiamondIndex";
import DiaryRarity from "./diaryRarity";
import DiaryColorCause from "./diaryColorCause";
import { FamousDiary } from "../../utils/famousDiary";
import FaceUpDiary from "./faceUpDiary";
import FcrfContext from "../../Context";
import { getColorCode } from "../../utils/graphColor";
import { encryptString } from "../../utils/encryptText";
import { clientPath, serverPath } from "../../config/key";
import { updateSubMetaField } from "../../utils/updateSubMetaField";
import { Spinner } from "react-bootstrap";
import { getFormattedDate, getFormattedIsoDate } from "../../utils/dateUtils";
import SaveNotificationModal from "../Models/saveNotificationModal";
import { toast } from "react-toastify";
import {
  getDefaultSideBarMenuArray,
  getMatchingTitles,
  newSideBarValidate,
  getSideBarMenuArray,
} from "../../utils/sidebarMenuItems";
import VerticalDropdown from "../verticalDropdown/verticalDropdown";
import {
  CopyIcon,
  DiamondIcon,
  HistoryIcons,
  SaveIcons,
  SettingsIcons,
} from "../verticalDropdown/svgData";
import "./diary.css";
import ScrollToTop from "../common/scrolltotop";

const DiaryReportPage = () => {
  const getContext = useContext(FcrfContext);
  const {
    sidebarCard,
    showAllCard,
    sidebarCardId,
    setSidebarCard,
    setSidebarCardId,
    setShowAllCard,
    pdfReportData,
    showDiaryReportNow,
    setShowDiaryReportNow,
    savedNotification,
    prevLocation,
    setPrevLocation,
    setSavedNotification,
    setNavigateFromPage,
    sidebarCardMainCopy,
    setDateSetting,
    dateSetting,
    setMainDiary_collab_credit,
    setMainRarity_collab_credit,
    isActiveVerify
  } = getContext;
  const navigate = useNavigate();
  const location = useLocation();
  const [reportData, setReportData] = useState(null);
  const [reportId, setReportId] = useState({
    Id: "",
    postId: "",
    recordName: "",
    raritypdfUrl: "",
  });
  const [loading, setLoading] = useState(true);
  const [imgScaleVal, setImgScaleVal] = useState(1);

  // const [showIndexCard, setSowIndexCard] = useState(true);
  const [copied, setCopied] = useState(false);
  const [urlValue, setUrlValue] = useState(null);
  const [shareID, setshareID] = useState("");
  const [isActive, setIsActive] = useState(false);
  const [reportGeneratedDate, setReportGeneratedDate] = useState("");
  const [saveBtn, setSaveBtn] = useState(false);
  // Origin mine change states
  const [selectedMine, setSelectedMine] = useState("");
  const [updateOriginLoading, setUpdateOriginLoading] = useState(false);
  const [showNewMinePopup, setShowNewMinePopup] = useState(true);
  const [showOriginContentPopup, setShowOriginContentPopup] = useState(false);
  const [runVideo, setRunVideo] = useState(false);
  const [manualHiddenCardsKeys, setManualHiddenCardsKeys] = useState([]);

  useEffect(() => {
    const { action } = location.state ?? {};
    console.log("action",action);
    if (action !== "Create") {
      getReportById();
    } 
  }, [location]);

  useEffect(() => {
    
    const { action } = location.state ?? {};
    if (action === "Create" && !isActiveVerify) {
      handleSubmit();
    }
  }, [isActiveVerify]);

  const handleSubmit = async () => {
    console.count('handle-submit-called');
    // setLoading(true);
    console.log("isActiveVerify",isActiveVerify);
    // if(isActiveVerify){
    //   return handleSubmit()
    // }
    try {
      const is_child_access = localStorage.getItem("is_child_access");
      const child_access = JSON.parse(is_child_access);
      const {
        is_a_child_user,
        parent_subscription_id,
        curr_user_id,
        parent_user_id,
      } = child_access || {};
      const { filter,isOldReportFound } = location.state;
      const copyfilterdata = { ...filter };
      
      const { is_free, is_subscription, is_role, subscription_id, product_id } =
        getlocalStorage();
      copyfilterdata.free = is_free;
      copyfilterdata.subscription = is_subscription || "not active";
      copyfilterdata.role = is_role;

      const subscriptionId =
        is_a_child_user === true ? parent_subscription_id : subscription_id;
      const productId =
        is_a_child_user === true ? parent_subscription_id : product_id;
      // const userID = is_a_child_user === true ? curr_user_id : curr_user_id;
      copyfilterdata["parentUserId"] =
        is_a_child_user === true ? parent_user_id : curr_user_id;
      copyfilterdata["defaultCategorySettings"] =
        getDefaultSideBarMenuArray(sidebarCardMainCopy);
       copyfilterdata["isOldReportFound"]=isOldReportFound
      const response = await rarityInstance().post(
        "diamond/diamond_diary",
        copyfilterdata
      );

      const {
        status,
        report,
        attemptedcount,
        Id,
        type,
        postId,
        rairtyPostID,
        statusCode,
        createdAt,
        raritypdfUrl,
        rairtyID
      } = response.data || {};

      if (statusCode === 401) {
        setLoading(false);
        navigate("/diary", {
          state: { from: "diaryreport", ischeck: true, type: "unauthorized" },
        });
      }

      if (status === 203) {
        setLoading(false);
        navigate("/diary", {
          state: { from: "diaryreport", ischeck: true, type },
        });
      }
      if (status === 200) {
        const isoDate = getFormattedIsoDate(report?.diaryInfo?.rarityInfo?.E68);
        setDateSetting({
          stringDate: report?.diaryInfo?.rarityInfo?.E68,
          isoDate: isoDate,
        });
        const res = await rarityInstance().get(
          `diamond/get-report-count?reportNumber=${copyfilterdata.report_number}&pWpUserId=${copyfilterdata["parentUserId"]}`
        );
        const { code, isOldReportFound } = res.data || {};
        if (code === 200 && !isOldReportFound) {
          console.log("curr_user_id=>>>>>>>>>>>>>>>>", curr_user_id);
          const result = await updateSubMetaField(
            subscriptionId,
            productId,
            "diary",
            curr_user_id
          );
          
          console.log("result.diary_collab_credit", result?.diary_collab_credit);
          setMainDiary_collab_credit(result?.diary_collab_credit);
          setMainRarity_collab_credit(result?.rarity_collab_credit);
          await rarityInstance().put(`diamond/update-report-credit-status`, {
            reportNumber: copyfilterdata.report_number,
            previousReportCreatedAt: createdAt,
          });
        }
        const obj = {
          Id,
          postId,
          rairtyPostID,
          raritypdfUrl,
          rairtyID
        };
        setReportId(obj);
        localStorage.setItem("dairyattemptedcount", attemptedcount);
        setReportData(report);
        setShowNewMinePopup(report?.range_slider?.originMatch);
        setRunVideo(report?.range_slider?.originMatch);
        setSelectedMine(report?.range_slider?.origin);
        handleShare(sidebarCard, obj);
        navigate("/diary-report", {
          state: {
            Id: Id,
            postId,
            action: "Get",
          },
        });
      }
    } catch (e) {
      setLoading(false);
      console.log("handleSubmit error", e);
    }
  };

  const getReportById = async () => {
    //setLoading(true);
    try {
      const { Id } = location.state;
      const response = await rarityInstance().get(
        `diamond/getreportbyId/${Id}`
      );
      const { status, getReport } = response?.data;
      const {
        _id,
        postId,
        report,
        rairtyPostID,
        createdAt,
        parentId,
        recordName,
        rairtyID,
      } = getReport || {};
      if (status === 200) {
        const { origanalShowCardId, sidebarCard,raritypdfUrl } = report || {}
        const obj = {
          Id: _id,
          postId,
          rairtyPostID,
          recordName,
          raritypdfUrl,
          rairtyID
        };
        if (parentId) {
          obj.parentId = parentId;
        }

        // const sideBarCardData = report?.sidebarCard
        //   ? report.sidebarCard
        //   : sidebarCard;
        setSidebarCard(origanalShowCardId);
        setReportId(obj);
        setReportData(report);
        setShowNewMinePopup(report?.range_slider?.originMatch);
        setSelectedMine(report?.range_slider?.origin);
        setReportGeneratedDate(getFormattedDate(createdAt || new Date()));
        setRunVideo(report?.range_slider?.originMatch);
        handleShare(sidebarCard, obj);
        if (location.state.from === "diarySearchHistory") {
          setLoading(false);
        }
      }
    } catch (error) {
      setLoading(false);
      console.log("error", error);
    }
  };

  const {
    data,
    diaryInfo,
    closestDiamondValues,
    closestDiamondDates,
    gia_report,
    range_slider,
    extdyarypdfUrl,
    extraritypdfUrl,
  } = reportData || {};
  const {
    originInfo,
    shapInfo,
    profilerInfo,
    florescenceInfo,
    weightInfo,
    saturationInfo,
    clarityInfo,
    rarityInfo,
    colorInfo,
    famousDiamondInfo,
    appreciation,
    weightCategory,
  } = diaryInfo || {};

  let textColor = "#333";
  const color = getColorCode(data?.color);

  const famousView =
    FamousDiary.filter(
      (elem) => gia_report?.results?.color_grade === elem.color
    ) || [];

  const handleCreateNewReport = async () => {
    setSidebarCard(sidebarCardMainCopy);
    setSidebarCardId([]);
    navigate("/diary");
  };

  const sizeValueInit =
    gia_report?.results?.data?.measurements?.length /
      gia_report?.results?.data?.measurements?.width || 0;

  const sizeValue =
    sizeValueInit.toString().match(/^-?\d+(?:\.\d{0,2})?/)[0] || 0;

  useEffect(() => {
    if (
      range_slider?.shapeName === "Cushion" ||
      range_slider?.shapeName === "Radiant"
    ) {
      if (sizeValue <= 1.05) {
        setImgScaleVal(1);
      } else if (sizeValue >= 1.06 && sizeValue <= 1.14) {
        setImgScaleVal(1.075);
      } else if (sizeValue >= 1.15 && sizeValue <= 1.24) {
        setImgScaleVal(1.15);
      } else if (sizeValue >= 1.25 && sizeValue <= 1.34) {
        setImgScaleVal(1.225);
      } else if (sizeValue >= 1.35) {
        setImgScaleVal(1.25);
      }
    } else if (range_slider?.shapeName === "Emerald") {
      if (sizeValue <= 1.14) {
        setImgScaleVal(0.775);
      } else if (sizeValue >= 1.15 && sizeValue <= 1.24) {
        setImgScaleVal(0.85);
      } else if (sizeValue >= 1.25 && sizeValue <= 1.34) {
        setImgScaleVal(0.925);
      } else if (sizeValue >= 1.35 && sizeValue <= 1.44) {
        setImgScaleVal(1);
      } else if (sizeValue >= 1.45) {
        setImgScaleVal(1.075);
      }
    }
  }, [sizeValue]);
  const handleShare = async (cardData, objData) => {
    try {
      const response = await rarityInstance().post(
        "diamond/shareDiaryHistory",
        {
          reportID: objData?.Id,
          postId: objData?.postId,
          showCard: cardData,
        }
      );
      const { status, shareId } = response.data || {};
      if (status === 200) {
        const obj = {
          shareId: {
            shareId
          },
        };
        setshareID(shareId);
        // const reportEncId = encryptString(obj);
        // const shareLink = `${clientPath}/share-diary-report/${obj.shareId.shareId}`;
        const shareLink = `${serverPath}/share-diary-report/${obj.shareId.shareId}`;
        setUrlValue(shareLink);
      }
    } catch (err) {
      console.error("Failed to copy: ", err);
    }
  };
  const handleCopy = async () => {
    setCopied(true);
    setTimeout(() => {
      setCopied(false);
    }, 2000);
    try {
      const {showCardId} = reportData || {}
      //const hiddenCards = getMatchingTitles(manualHiddenCardsKeys);
      const {displaySettings, hiddenSettings} = getSideBarMenuArray(sidebarCard, showCardId);
      await rarityInstance().post("diamond/copy-share-link/Diary", {
        hiddenCards: [displaySettings, hiddenSettings],
        reportId: reportId.postId,
        shareLink: urlValue,
      });
    } catch (error) {
      console.error("error in copy link===", error);
    }
  };

  const goToRairtyReport = async () => {
    window.open(extraritypdfUrl);
    // extraritypdfUrl
    const { rairtyPostID, rairtyID:Id } = reportId || {};
    const rairtyID = rairtyPostID?.replace("#", "");
    let obj = {
      Id,
      postId: rairtyPostID
    }
    // const reportEncId = encryptString(obj);
    // const shareLink = `${clientPath}/share-rarity-report?id=${reportEncId}`;
    // const shareLink = `${clientPath}/share-rarity-report/${obj.Id}`;
      const shareLink = `${serverPath}/share-rarity-report/${obj.Id}`;


   const updatedData =  await withoutAuth().post(
      "report/updateReportStatusbyId",{
      rairtyID,
      stringDate:dateSetting?.stringDate,
      shareLink
    }
    );
    // console.log("pdfUrl", updatedData)
    await rarityWebhook(updatedData?.data?.pdfUrl);
    // const {
    //   pdfUrl
    // } = result?.data || {}; //result is variable from withoutAuth api
    //console.log("result?.data ==>", result?.data)
    // window.open(pdfUrl, "_blank");
    // const url = `/report?Id=${rairtyID}&from=diary&pId=${Id}`;
    // localStorage.setItem("sendViewRarity", reportId.postId);
    // console.log("urlll =>", url);
    // navigate(url);
  };
  const formatDateReport = (input) => {
    const dateObject = new Date(input);
    if (isNaN(dateObject.getTime())) {
      return 'Invalid Date';
    }
    const day = dateObject.getDate();
    const month = dateObject.getMonth() + 1;
    const year = dateObject.getFullYear();
    const formattedDate = `${day}.${month}.${year}`;
    return formattedDate;
  };
  const formatDate = (inputDate) => {
    const dateComponents = inputDate?.match(/(\w+) (\d+)(?:st|nd|rd|th), (\d+)/);
    if (!dateComponents) {
      return 'Invalid Date';
    }
    const months = {
      January: 0,
      February: 1,
      March: 2,
      April: 3,
      May: 4,
      June: 5,
      July: 6,
      August: 7,
      September: 8,
      October: 9,
      November: 10,
      December: 11,
    };
    const month = months[dateComponents[1]];
    const day = dateComponents[2];
    const year = dateComponents[3];
    const date = new Date(year, month, day);
    const formattedDate = `${date.getDate()}.${date.getMonth() + 1}.${date.getFullYear()}`;
    return formattedDate;
  };

  const rarityWebhook = async (pdfUrl) =>{
    try {
      // console.log("payload", reportId)
      const { rairtyPostID,postId,rairtyID} = reportId || {};
      const obj = {
        Id: rairtyID,
        postId: rairtyPostID,
      };
      //console.log("reportId =>", reportId);
      const reportEncId = encryptString(obj);
      const shareLink = `${clientPath}/share-rarity-report?id=${reportEncId}`;
      await rarityInstance().post("report/rarity-from-diary", {
        rarityUrl: shareLink,
        rarityReportId: rairtyPostID,
        reportId: postId,
        id:rairtyID,
        rarityPDFUrl:pdfUrl
      });
    } catch (error) {
      console.log("error in rarity-from-diary api", error);
    }
  }

  const handleShowAllCard = () => {
    setSidebarCard(sidebarCardMainCopy);
    setSidebarCardId([]);
    handleShare(sidebarCardMainCopy, reportId);
  };

  const handleSaveReport = async () => {
    const { Id, postId, recordName } = reportId;
    setSaveBtn(true);
    try {
      const copySideBarCard = { ...sidebarCard };
      const validatedObj = newSideBarValidate(
        copySideBarCard,
        diaryInfo,
        data,
        gia_report,
        range_slider
      );
      const { displaySettings } = getDefaultSideBarMenuArray(validatedObj);
      const { report_number } = reportData?.data || {};
      const hiddenCards = getMatchingTitles(manualHiddenCardsKeys);
      // const recordName = reportData?.recordName || ""
     const result=  await rarityInstance().post(`diamond/saveReport`, {
        reportId: Id,
        recordName: recordName
          ? recordName
          : `${data?.saturation} ${data?.colorName} ${data?.weight}ct`,
        sidebarCard,
        releventCards: {
          displayCards: displaySettings,
          hiddenCards: hiddenCards,
        },
        shareLink: urlValue,
        postId,
        report_number,
      });
      const { report  } = result?.data?.data || {}
      const { origanalShowCardId } = report || {}
      //console.log("result =>", result)
      setSavedNotification(true);
      setTimeout(() => {
        setSaveBtn(false);
        setSavedNotification(false);
        setNavigateFromPage("/diary-report");
        setSidebarCard(origanalShowCardId);
        navigate("/diary-save-history", {
          state: {
            Id: Id,
          },
        });
      }, 3000);
    } catch (err) {
      toast.error(err?.response?.data?.msg || "Internal server error", {
        toastId: "Save Report",
      });
    }
  };

  const handleSideBarCard = async (key, value) => {
    console.log("handleSideBarCard =>", {key, value, sidebarCard})
    const copySidebarCardId = { ...sidebarCard };
    copySidebarCardId[key] = !value;
    setSidebarCard(copySidebarCardId);
    console.log("shareID ==>", { shareID, copySidebarCardId });
    const manualHiddenCardsKeysCopy = { ...manualHiddenCardsKeys };
    //setSidebarCard({ ...sidebarCard, [key]: !value });
    if (sidebarCardId.find((elem) => elem === key)) {
      const findElem = sidebarCardId.find((elem) => elem === key);
      const elemIndex = sidebarCardId.indexOf(findElem);
      if (elemIndex > -1) {
        sidebarCardId.splice(elemIndex, 1);
        setSidebarCardId([...sidebarCardId]);
        // For only hide manual cards
        delete manualHiddenCardsKeysCopy[key];
        setManualHiddenCardsKeys(manualHiddenCardsKeysCopy);
      }
    } else {
      setSidebarCardId([...sidebarCardId, key]);
      // For only hide manual cards
      manualHiddenCardsKeysCopy[key] = key;
      setManualHiddenCardsKeys(manualHiddenCardsKeysCopy);
    }
    handleShare(copySidebarCardId, reportId);
    // if(shareID){
    //   console.log("sidebarCard and ID ==>", {
    //     copySidebarCardId, shareID
    //   })
    //   const response = await rarityInstance().post(
    //     "diamond/updateShareDiaryHistory",
    //     {
    //       id: shareID,
    //       showCard: copySidebarCardId,
    //     }
    //   );
    //   console.log("response ==>", response)
    // }
  };

  useEffect(() => {
    if (sidebarCardId.length > 0) {
      setShowAllCard(false);
    } else {
      setShowAllCard(true);
      setSidebarCardId([]);
    }
  }, [sidebarCard]);

  const handleDownLoadReport = async (chartId, weightChartID) => {

    setIsActive(true);
    window.open(extdyarypdfUrl);
    setIsActive(false);
    const {showCardId} = reportData || {}
    const formData = new FormData();
    const chartInstanceWeight = window.Apex._chartInstances.find(
      (chart) => chart.id === weightChartID
    );
    const base64Weight = await chartInstanceWeight?.chart?.dataURI();
    if (base64Weight) {
      const blobWeight = await fetch(base64Weight.imgURI).then((res) =>
        res.blob()
      );
      formData.append("files", blobWeight, "pie-graph.png");
    }
    const copySideBarsObj = { ...sidebarCard };
    const copyPdfReportData = { ...pdfReportData };
    for (let key in copySideBarsObj) {
      if (
        copySideBarsObj.hasOwnProperty(key) &&
        typeof copySideBarsObj[key] === "boolean" &&
        !copySideBarsObj[key]
      ) {
        delete copyPdfReportData[key];
      }
    }
    const copySideBarCard = { ...sidebarCard };
    const validatedObj = newSideBarValidate(
      copySideBarCard,
      diaryInfo,
      data,
      gia_report,
      range_slider
    );
  
    //const hiddenCards = getMatchingTitles(manualHiddenCardsKeys);
    const { displaySettings,hiddenSettings } = getSideBarMenuArray(validatedObj, showCardId);
    copyPdfReportData.reportId = reportId;
    copyPdfReportData.sidebarCard = sidebarCard;
    copyPdfReportData.reportDateAndTIme = reportGeneratedDate;
    copyPdfReportData.cardDetails = {
      releventCards: [displaySettings, hiddenSettings],
      hiddenCards: [],
    };

    if (copyPdfReportData?.indexBox) {
      copyPdfReportData.indexBox.closestDiamondDates = closestDiamondDates;
      copyPdfReportData.indexBox.closestDiamondValues = closestDiamondValues;
    }


    copyPdfReportData.stringDate = dateSetting?.stringDate;
    copyPdfReportData.shareUrl = urlValue;
    formData.append("pdfReportData", JSON.stringify(copyPdfReportData));
    try {
      const response = await rarityInstance().post(
        "diamond/download",
        formData
      );
      const { pdfurl, status } = response?.data || {};
      console.log("pdfurlpdfurl =>", pdfurl);
      if (status === 200) {
        
        // window.open(pdfurl, "_blank");
        console.log("Image uploaded successfully!");
        // Perform any additional actions after successful upload
      } else {
        console.error("Image upload failed.");
        // Handle the error case
      }
    } catch (error) {
      
      console.error("Error occurred while uploading image:", error);
      // Handle the error case
    }
  };

  const updateOrigin = async (updateOrigin) => {
    if (updateOrigin && selectedMine === reportData?.data?.mine) {
      setShowNewMinePopup(!showNewMinePopup);
      setShowNewMinePopup(false);
      setShowOriginContentPopup(false);
      return;
    }
    setUpdateOriginLoading(true);
    console.log('reportData---',reportId)
    const payload = { report_number: reportData.data.report_number, diaryPId: reportId.postId, rairtyPostID: reportId.rairtyPostID };
    if (updateOrigin) {
      payload.mine = selectedMine;
    } else {
      payload.reportId = reportId.postId;
    }

    try {
      const response = await rarityInstance().post(
        `diamond/change-origin/${reportId?.Id ? reportId.Id : ""}`,
        payload
      );
      if (!updateOrigin) {
        setShowNewMinePopup(!showNewMinePopup);
        setRunVideo(true);
        return;
      }
      const {
        status,
        report,
        attemptedcount,
        Id,
        type,
        postId,
        rairtyPostID,
        statusCode,
        //createdAt,
      } = response?.data || {};
      //console.log("response report  =>", response.data);
      if (statusCode === 401) {
        setUpdateOriginLoading(false);
        navigate("/diary", {
          state: { from: "diaryreport", ischeck: true, type: "unauthorized" },
        });
      }

      if (status === 203) {
        setUpdateOriginLoading(false);
        navigate("/diary", {
          state: { from: "diaryreport", ischeck: true, type },
        });
      }
      if (status === 200) {
        const obj = {
          Id,
          postId,
          rairtyPostID,
        };
        setReportId(obj);
        localStorage.setItem("dairyattemptedcount", attemptedcount);
        setReportData(report);
        setShowNewMinePopup(false);
        setShowOriginContentPopup(false);
        setUpdateOriginLoading(false);
        setShowNewMinePopup(report?.range_slider?.originMatch);
        setSelectedMine(report?.range_slider?.origin);
        setRunVideo(report?.range_slider?.originMatch);
        handleShare(sidebarCard, obj);
        navigate("/diary-report", {
          state: {
            Id: Id,
            postId,
            action: "Get",
          },
        });
      }
    } catch (error) {
      setUpdateOriginLoading(false);
      console.log("error in update origin=>>>", error);
    }
  };
  useEffect(() => {
    if (showDiaryReportNow && reportData) {
      setLoading(false);
      setShowDiaryReportNow(false);
    } else if (
      (prevLocation === "/diary-history-report" ||
        prevLocation === "/diary-save-history") &&
      reportData
    ) {
      setTimeout(() => {
        setLoading(false);
        setShowDiaryReportNow(false);
        setPrevLocation("");
      }, 500);
    }
  }, [showDiaryReportNow, reportData, prevLocation]);

  const dropdownItems = [
    {
      icon: CopyIcon,
      sharefun: handleCopy,
      label: "Copy Report Link",
      urlValue: urlValue,
    },
    {
      icon: HistoryIcons,
      route: "/diary-history-report",
      label: "Search History",
    },
    { icon: SaveIcons,  label: "Saved Reports",sharefun: handleSaveReport },
    { icon: SettingsIcons, route: `/settings`, label: "Report Settings" },
  ];
if(reportData?.gia_report?.report_number){
    dropdownItems.push({
      icon: DiamondIcon,
      route: `/valuation/?gia=${reportData?.gia_report?.report_number}`,
      label: "Ask for Valuation",
    },)
  }
  return (
    <>
      {loading && <Loader type="progress" />}
      <DiaryLayout
        sideBar={true}
        header={true}
        handleSideBarCard={handleSideBarCard}
        sidebarCard={sidebarCard}
      >
        <div className="diary-page">
          <div className="container">
            <div className="diary-wrapper">
              <div className="diary-title">
                <h1 className="report-page-hedding">
                <span className="beta-top-report-page">[BETA]</span>
                  Diamond diary Report<span className="sup-text">™</span> 
                </h1>

                <div className="report-action-btn toolcard-action-btn report-action-dot">
                  <div className="d-flex report-action-gap">
                  <Button
                    className="outline-btn diamond-new-report"
                    onClick={() => handleCreateNewReport()}
                  >
                    <PlusIcon />
                    <span>New</span>
                  </Button>

                  <Button
                    disabled={isActive}
                    className="outline-btn pdf-btn"
                    onClick={() =>
                      handleDownLoadReport(
                        "index-graph-pdf",
                        "weight-graph-pdf"
                      )
                    }
                  >
                    {isActive ? (
                      <Spinner animation="border" />
                    ) : (
                      <>
                        <DownloadIcon />
                        <span>PDF</span>
                      </>
                    )}
                  </Button>

                  <Button
                    className="outline-btn"
                    onClick={() => handleSaveReport()}
                    disabled={saveBtn}
                  >
                    {saveBtn ? (
                      <Spinner animation="border" />
                    ) : (
                      <>
                        <SaveIcon />
                        <span>Save</span>
                      </>
                    )}
                  </Button>
                  </div>
                  <div className="copy-btn-wrapper">
                    <span className={`copied-tooltip ${copied ? "show" : ""}`}>
                      Copied
                    </span>
                  </div>
                  <VerticalDropdown dropdownItems={dropdownItems} />
                </div>
              </div>

              <DiaryGIA
                reportData={reportData}
                florescenceInfo={florescenceInfo}
                imgScaleVal={imgScaleVal}
                range_slider={range_slider}
                showAllCard={showAllCard}
                handleShowAllCard={handleShowAllCard}
                colorCode={color}
                sidebarCard={sidebarCard}
              />
              {originInfo?.C46 !== "#N/A" && (
                <DiaryOrigin
                  originInfo={originInfo}
                  sidebarCard={sidebarCard}
                  handleSideBarCard={handleSideBarCard}
                  mineName={selectedMine}
                  setSelectedMine={setSelectedMine}
                  updateOrigin={updateOrigin}
                  updateOriginLoading={updateOriginLoading}
                  showNewMinePopup={showNewMinePopup}
                  setShowNewMinePopup={setShowNewMinePopup}
                  showOriginContentPopup={showOriginContentPopup}
                  setShowOriginContentPopup={setShowOriginContentPopup}
                  showOriginChangeFeature={
                    location?.state?.from === "diarySearchHistory"
                      ? false
                      : true
                  }
                  runVideo={runVideo}
                />
              )}
              {colorInfo?.C18 !== "#N/A" && (
                <DiaryColorCause
                  colorInfo={colorInfo}
                  gia_report={gia_report}
                  data={data}
                  color={color}
                  sidebarCard={sidebarCard}
                  handleSideBarCard={handleSideBarCard}
                />
              )}
              {saturationInfo?.C30 !== "#N/A" && (
                <DiarySaturation
                  data={data}
                  saturationInfo={saturationInfo}
                  color={color}
                  sidebarCard={sidebarCard}
                  handleSideBarCard={handleSideBarCard}
                  range_slider={range_slider}
                />
              )}
              {shapInfo?.C24 !== "#N/A" && (
                <DiaryShape
                  shapInfo={shapInfo}
                  diaryInfo={reportData?.diaryInfo}
                  data={data}
                  imgScaleVal={imgScaleVal}
                  sidebarCard={sidebarCard}
                  handleSideBarCard={handleSideBarCard}
                  gia_report={gia_report}
                />
              )}
              {profilerInfo?.C58 !== "#N/A" && (
                <FaceUpDiary
                  profilerInfo={profilerInfo}
                  data={data}
                  gia_report={gia_report}
                  imgScaleVal={imgScaleVal}
                  range_slider={range_slider}
                  sidebarCard={sidebarCard}
                  handleSideBarCard={handleSideBarCard}
                />
              )}
              {weightInfo?.C34 !== "#N/A" && (
                <DiaryWeight
                  weightInfo={weightInfo}
                  color={color}
                  sidebarCard={sidebarCard}
                  handleSideBarCard={handleSideBarCard}
                  weightCategory={weightCategory}
                />
              )}
              {weightInfo?.C34 !== "#N/A" && (
                <DiaryWeightPDF
                  weightInfo={weightInfo}
                  color={color}
                  sidebarCard={sidebarCard}
                  handleSideBarCard={handleSideBarCard}
                  weightCategory={weightCategory}
                />
              )}

              {clarityInfo?.C38 !== "#N/A" && (
                <DiaryClarity
                  clarityInfo={clarityInfo}
                  color={color}
                  textColor={textColor}
                  sidebarCard={sidebarCard}
                  handleSideBarCard={handleSideBarCard}
                />
              )}
              {gia_report?.results?.fluorescence !== "None" &&
                florescenceInfo?.C42 !== "#N/A" && (
                  <DiaryFluorescence
                    florescenceInfo={florescenceInfo}
                    data={data}
                    sidebarCard={sidebarCard}
                    handleSideBarCard={handleSideBarCard}
                  />
                )}
              {range_slider?.showRarityCard === "TRUE" &&
                (rarityInfo?.C62 !== "#N/A" || rarityInfo?.C64 !== "#N/A") && (
                  <DiaryRarity
                    rarityInfo={rarityInfo}
                    data={data}
                    color={color}
                    goToRairtyReport={goToRairtyReport}
                    sidebarCard={sidebarCard}
                    handleSideBarCard={handleSideBarCard}
                    reportId={reportId?.Id}
                    stringDate={dateSetting?.stringDate}
                    extraritypdfUrl={ extraritypdfUrl}

                  />
                )}
              {(data?.color === "Blue" ||
                data?.color === "Pink" ||
                data?.color === "Yellow" ||
                data?.color === "Pink - Purplish Pink" ||
                data?.color === "Pink/Purple/ish Pink") &&
                (data?.saturation === "Fancy" ||
                  data?.saturation === "Fancy Intense" ||
                  data?.saturation === "Fancy Vivid") &&
                parseFloat(data?.weight) >= 1 &&
                appreciation?.C72 !== "#N/A" && (
                  <DiaryDiamondIndex
                    color={color}
                    data={data}
                    closestDiamondValues={closestDiamondValues}
                    closestDiamondDates={closestDiamondDates}
                    colorName={reportData?.data?.color || ""}
                    saturationName={reportData?.data?.saturation || ""}
                    indexResult={reportData?.indexResult || ""}
                    sidebarCard={sidebarCard}
                    handleSideBarCard={handleSideBarCard}
                    appreciation={appreciation}
                  />
                )}
              {!(
                famousDiamondInfo?.C50 === "#N/A" ||
                famousDiamondInfo?.C50?.includes("#NUM!") ||
                !famousDiamondInfo
              ) ? (
                <LuxuryHistory
                  famousDiamondInfo={famousDiamondInfo}
                  famousView={famousView[0] || []}
                  sidebarCard={sidebarCard}
                  handleSideBarCard={handleSideBarCard}
                />
              ) : (
                ""
              )}

              <div className="rarity-tool-grid1 diary-tool-grid">
                <div className="rarity-tool-right1">
                  <div className="report-action-btn diamond_diary_btn">
                    <Button
                      className="outline-btn diamond-new-report"
                      onClick={() => handleCreateNewReport()}
                    >
                      <PlusIcon />
                      <span>New</span>
                    </Button>

                    <Button
                      disabled={isActive}
                      className="outline-btn"
                      onClick={() =>
                        handleDownLoadReport(
                          "index-graph-pdf",
                          "weight-graph-pdf"
                        )
                      }
                    >
                      {isActive ? (
                        <Spinner animation="border" />
                      ) : (
                        <>
                          <DownloadIcon />
                          <span>PDF</span>
                        </>
                      )}
                    </Button>

                    <Button
                      className="outline-btn"
                      onClick={() => handleSaveReport()}
                      disabled={saveBtn}
                    >
                      {saveBtn ? (
                        <Spinner animation="border" />
                      ) : (
                        <>
                          <SaveIcon />
                          <span>Save</span>
                        </>
                      )}
                    </Button>

                    <div className="copy-btn-wrapper">
                      {urlValue && (
                        <CopyToClipboard
                          text={urlValue}
                          onCopy={(e) => handleCopy(e)}
                        >
                          <Button className="outline-btn">
                            <ExportIcon />
                          </Button>
                        </CopyToClipboard>
                      )}
                      <span
                        className={`copied-tooltip ${copied ? "show" : ""}`}
                      >
                        Copied
                      </span>
                    </div>
                  </div>
                  <ScrollToTop scrollClass={"scroll-up2"}/>
                </div>
                <div className="rarity-tool-left1">
                  <div className="agyle-disclaimer">
                    <span className="rarity-tool-text">
                      The data on the Fancy Color Diamond Diary© may change from
                      time to time and is not a guarantee or a reflection of the
                      diamond's value. The origin of the diamond is provided
                      solely according to the input of the person for whom the
                      report was produced. The gemological description of the
                      diamond is obtained from the GIA website. To maintain the
                      accuracy and currency of the information, it is advised to
                      periodically update the diary, especially prior to each
                      use. For additional information about the data and other
                      limitations, please contact us at{" "}
                      <a href="mailto:customers@fcresearch.org">
                        customers@fcresearch.org
                      </a>
                      .
                    </span>
                  </div>
                </div>
                <p className="report-timestamp   d-block d-md-none">

<span>Report generated on {formatDateReport(reportData?.timestamp)} </span>
<br/>
<span> Last data update on {formatDate(range_slider?.textSheetData?.H12)}</span>
</p>
                <p className="report-timestamp d-none d-md-block">
                     Report generated on {formatDateReport(reportData?.timestamp)} |
                     Last data update on {formatDate(range_slider?.textSheetData?.H12)}
                    </p>
              </div>
            </div>
          </div>
        </div>
        {savedNotification && (
          <SaveNotificationModal
            message="Added to your saved reports"
            undoBtn={false}
          />
        )}
      </DiaryLayout>
    </>
  );
};

export default DiaryReportPage;

const ExportIcon = () => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M6.74707 4.00047H10.2111C10.4011 4.00053 10.584 4.07271 10.7229 4.20244C10.8617 4.33217 10.9461 4.50977 10.9591 4.69935C10.972 4.88893 10.9126 5.07636 10.7926 5.22377C10.6727 5.37117 10.5013 5.46757 10.3131 5.49347L10.2111 5.50047H6.74707C6.17711 5.50038 5.62835 5.71661 5.21164 6.10547C4.79493 6.49434 4.54133 7.02686 4.50207 7.59547L4.49707 7.75047V17.2505C4.49725 17.8204 4.71373 18.3691 5.10278 18.7856C5.49183 19.2021 6.02445 19.4555 6.59307 19.4945L6.74707 19.5005H16.2471C16.8172 19.5005 17.3661 19.2842 17.7828 18.8951C18.1996 18.506 18.453 17.9733 18.4921 17.4045L18.4971 17.2505V16.7525C18.4951 16.5611 18.5664 16.3762 18.6963 16.2357C18.8263 16.0952 19.005 16.0096 19.1959 15.9966C19.3869 15.9835 19.5756 16.044 19.7234 16.1656C19.8712 16.2871 19.967 16.4606 19.9911 16.6505L19.9971 16.7525V17.2505C19.9969 18.2103 19.6287 19.1335 18.9683 19.83C18.3079 20.5265 17.4055 20.9433 16.4471 20.9945L16.2471 21.0005H6.74707C5.78691 21.0005 4.8633 20.6323 4.16656 19.9717C3.46981 19.311 3.05302 18.4083 3.00207 17.4495L2.99707 17.2495V7.74947C2.99724 6.78964 3.36544 5.86642 4.02586 5.16992C4.68627 4.47341 5.58861 4.05666 6.54707 4.00547L6.74707 4.00047ZM14.5001 6.52047V3.75047C14.5 3.61251 14.538 3.47721 14.6098 3.35943C14.6816 3.24166 14.7846 3.14599 14.9073 3.08293C15.03 3.01987 15.1677 2.99188 15.3053 3.00203C15.4428 3.01218 15.575 3.06009 15.6871 3.14047L15.7691 3.20847L21.7631 8.95847C22.0431 9.22747 22.0691 9.65847 21.8401 9.95647L21.7631 10.0415L15.7691 15.7935C15.6695 15.8891 15.5455 15.9553 15.4108 15.985C15.276 16.0147 15.1356 16.0066 15.0051 15.9616C14.8747 15.9166 14.7591 15.8365 14.6713 15.7301C14.5834 15.6237 14.5266 15.4951 14.5071 15.3585L14.5001 15.2515V12.5265L14.1561 12.5565C11.7561 12.8065 9.45607 13.8875 7.24207 15.8165C6.72207 16.2695 5.91907 15.8415 6.00507 15.1585C6.66907 9.83847 9.45107 6.90747 14.2001 6.53947L14.5001 6.52047ZM16.0001 5.50747V7.25047C16.0001 7.44938 15.9211 7.64014 15.7804 7.7808C15.6397 7.92145 15.449 8.00047 15.2501 8.00047C11.3761 8.00047 8.97607 9.67647 7.93807 13.1575L7.85907 13.4355L8.21107 13.1985C10.4501 11.7375 12.7981 11.0005 15.2511 11.0005C15.4325 11.0005 15.6077 11.0663 15.7443 11.1856C15.8809 11.3049 15.9696 11.4697 15.9941 11.6495L16.0011 11.7505V13.4935L20.1601 9.50047L16.0001 5.50747Z"
        fill="#bf8f02"
      />
    </svg>
  );
};

const PlusIcon = () => {
  return (
    <svg width="24" height="24" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M11 13H3v-2h8V3h2v8h8v2h-8v8h-2z"
        fill="#ffffff"
        fillRule="evenodd"
      />
    </svg>
  );
};

const DownloadIcon = () => {
  return (
    <svg width="24" height="24" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M20.156 15.242c.232 0 .447.097.6.25A.9.9 0 0 1 21 16.1v3.991l-.008.115-.02.107a.856.856 0 0 1-.833.687H3.856a.853.853 0 0 1-.845-.76C3 20.187 3 20.142 3 20.085v-3.992c0-.471.385-.852.85-.852a.852.852 0 0 1 .85.852v3.197h14.605v-3.197c0-.471.386-.852.85-.852zM12.01 3c.272 0 .522.114.703.29a.983.983 0 0 1 .29.704v9.215l2.51-2.515a.998.998 0 0 1 1.405 0 1.018 1.018 0 0 1-.017 1.408l-4.177 4.185c-.005.011-.017.017-.022.023a.984.984 0 0 1-.55.278c-.017 0-.034.006-.051.006l-.051.005H12l-.096-.005c-.017 0-.034-.006-.051-.006a.966.966 0 0 1-.55-.278l-.023-.023-4.177-4.185a.994.994 0 0 1-.289-.704c0-.255.097-.51.29-.704a.998.998 0 0 1 1.405 0l2.51 2.515V3.994c0-.545.448-.994.992-.994z"
        fill="#bf8f02"
        fillRule="evenodd"
      />
    </svg>
  );
};

const SaveIcon = () => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M6 3V19.38L10.5945 15.7035C10.9934 15.3844 11.4891 15.2105 12 15.2105C12.5109 15.2105 13.0066 15.3844 13.4055 15.7035L18 19.3785V3H6ZM5.25 1.5H18.75C18.9489 1.5 19.1397 1.57902 19.2803 1.71967C19.421 1.86032 19.5 2.05109 19.5 2.25V20.94C19.4998 21.0811 19.4598 21.2193 19.3846 21.3387C19.3093 21.4581 19.2019 21.5539 19.0747 21.615C18.9475 21.6761 18.8056 21.7001 18.6654 21.6841C18.5252 21.6682 18.3923 21.6131 18.282 21.525L12.468 16.875C12.3351 16.7689 12.1701 16.7111 12 16.7111C11.8299 16.7111 11.6649 16.7689 11.532 16.875L5.718 21.525C5.60772 21.6131 5.47483 21.6682 5.3346 21.6841C5.19438 21.7001 5.0525 21.6761 4.92529 21.615C4.79807 21.5539 4.69068 21.4581 4.61545 21.3387C4.54022 21.2193 4.5002 21.0811 4.5 20.94V2.25C4.5 2.05109 4.57902 1.86032 4.71967 1.71967C4.86032 1.57902 5.05109 1.5 5.25 1.5Z"
        fill="#bf8f02"
      />
    </svg>
  );
};
